module.exports = __webpack_public_path__ + "static/media/img1.d90e6bdf.jpg";